import { MIP_MANAGE_ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { mipManagePath } from '@dealstack/frontend/app/pages/Routing/routes.utils';
import { useBreadcrumbs } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { SummaryDealMip } from '@dealstack/shared/lib/generated';
import { useMemo } from 'react';
import { AddBreadcrumbItem } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs.types';

interface Props {
	view: 'home';
	dealId?: string;
	currentMip?: SummaryDealMip;
}

export const generateDocumentBreadcrumbs = (
	props: Props,
	tMipManage: ReturnType<typeof useTranslationMipManage>
): AddBreadcrumbItem[] => {
	switch (props.view) {
		case 'home': {
			const mipDocumentsUrl = mipManagePath(MIP_MANAGE_ROUTES.DOCUMENTS, {
				mipId: props?.currentMip?.id ?? '',
				dealId: props.dealId ?? '',
			});

			const suffixBreadcrumb = {
				name: tMipManage('documents_page.title'),
				url: mipDocumentsUrl,
				hideInAppHeader: true,
			};
			const mipUrl = mipManagePath(MIP_MANAGE_ROUTES.INVESTORS, {
				mipId: props?.currentMip?.id ?? '',
				dealId: props.dealId ?? '',
			});

			const mipBreadcrumb = {
				name: props?.currentMip?.programmeName ?? '',
				url: `${mipUrl}`,
				hideInAppHeader: true,
			};
			const documentDetailsBreadcrumb = {
				name: tMipManage('documents_page.breadcrumbs.document_details'),
				url: '',
				noLink: true,
				hideInAppHeader: true,
			};
			return [mipBreadcrumb, suffixBreadcrumb, documentDetailsBreadcrumb];
		}

		default:
			return [];
	}
};

export function useDocumentBreadcrumbs(props: Props) {
	const tMipManage = useTranslationMipManage();

	const breadcrumbs = useMemo(() => {
		return generateDocumentBreadcrumbs(props, tMipManage);
	}, [props, tMipManage]);

	useBreadcrumbs(breadcrumbs);
}
